import { IBOAccountList } from "./IBOAccountList";

export default IBOAccountList;
